import cjPontanegraApi from '../apis/cjPontanegraApi';

export const deleteSellerAvatarsService = async (
  sellerId: string,
): Promise<void> => {
  await cjPontanegraApi.delete(`/avatars/sellers/${sellerId}`);
};
